import React from 'react';
import { FormField } from '@cp/ds/src/components/form';
import { useStart } from '../../model/hooks/useStart';
import { FormFieldName } from '../../model/form';
import { StartFieldProps } from './model';

export const StartField: React.FC<StartFieldProps> = ({ form, submit, label, sx }) => {
  const { items, disabled } = useStart({ form, submit });

  return (
    <FormField
      disabled={disabled}
      fieldContainerProps={{ sx }}
      fieldLabel={label}
      itemListHeightMax={200}
      items={items}
      name={FormFieldName.Start}
      placeholder="Начало"
      size="small"
      type="select"
    />
  );
};
